import { useApi } from '../composables'
import http from '../composables/src/useHttp'
import type { CreateProductPayload, Product, UpdateProductPayload } from '../types/product'

export const getAllProducts = () => {
  return useApi<Product[]>(http.get('/products'))
}

export const getProductsByCustomerId = (customerId: string) => {
  return useApi<Product[]>(http.get(`/products/customer/${customerId}`))
}

export const createProduct = (data: CreateProductPayload) => {
  return useApi<Product>(http.post('/products', data))
}

export const updateProduct = (id: string, data: UpdateProductPayload) => {
  return useApi<Product>(http.patch(`/products/${id}`, data))
}

export const deleteProduct = (id: string) => {
  return useApi<{ id: string; message: string }>(http.delete(`/products/${id}`))
}

export const getProduct = (id: string) => {
  return useApi<Product>(http.get(`/products/${id}`))
}
